import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-carrossel',
  templateUrl: './carrossel.component.html',
  styleUrls: ['./carrossel.component.scss']
})
export class CarrosselComponent {
  timerSubs!: Subscription;
  private _imagens: { file: any, key: string }[] = [];
  @Input() set imagens(value: { file: any, key: string }[]) {
    this._imagens = value || [];
    if (this._imagens.length > 0) {
      this.indexImagemAtiva = 0;
      this.imagemAtiva.emit(this._imagens[0].key);
    }
  }
  get imagens(): { file: any, key: string }[] {
    return this._imagens;
  }
  @Input() renovabio: boolean = false;
  @Output() imagemAtiva = new EventEmitter<string>();
  private _indexImagemAtiva: number = 0;

  get indexImagemAtiva() {
    return this._indexImagemAtiva;
  }

  set indexImagemAtiva(value: number) {
    this._indexImagemAtiva = value < this.imagens.length ? value : 0;
  }

  ativarImagem(index: number): void {
    this.indexImagemAtiva = index;
    this.imagemAtiva.emit(this.imagens[index].key);
    // this.iniciarTimer();
  }

  // iniciarTimer(): void {
  //   this.timerSubs = timer(5000).subscribe(() => {
  //     this.ativarImagem(
  //       this.indexImagemAtiva + 1
  //     );
  //   });
  // }

  // pararTimer(): void {
  //   this.timerSubs?.unsubscribe();
  // }
}
